const Utils = require('../utils.js');

const Constants = {
   SetAllTopics: 'editor_SetAllTopics',
   SetTopicFilterArray: 'editor_SetTopicFilterArray',
   AddValueToTopicFilter: 'editor_AddValueToTopicFilter',
   RemoveValueFromTopicFilter: 'editor_RemoveValueFromTopicFilter',
   ClearTopicFilter: 'editor_ClearTopicFilter',
   SetCardTypeFilterArray: 'editor_SetCardTypeFilterArray',
   AddValueToCardTypeFilter: 'editor_AddValueToCardTypeFilter',
   RemoveValueFromCardTypeFilter: 'editor_RemoveValueFromCardTypeFilter',
   ClearCardTypeFilter: 'editor_ClearCardTypeFilter',
   AddValueToDeckFilter: 'editor_AddValueToDeckFilter',
   RemoveValueFromDeckFilter: 'editor_RemoveValueFromDeckFilter',
   ClearDeckFilter: 'editor_clearDeckFilter',
   SetCheckForValidationErrors: 'editor_SetCheckForValidationErrors',
   SetSearchString: 'editor_SetSearchString',
   SetShowLinkBtn: 'editor_SetShowLinkBtn'
};

exports.EditorReducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetAllTopics:
         return Object.assign({}, state, {allTopics: action.topics});
      case Constants.SetTopicFilterArray:
         return {...state, topicFilterArray: action.topicArray};
      case Constants.AddValueToTopicFilter: {
         let newArray = state.topicFilterArray.slice().push({id: action.id, value: action.value});
         return {...state, topicFilterArray: newArray}
      }
      case Constants.RemoveValueFromTopicFilter: {
         let newArray = state.topicFilterArray.filter(f => f.id !== action.id);
         return {...state, topicFilterArray: newArray}
      }
      case Constants.ClearTopicFilter: {
         return {...state, topicFilterArray: []}
      }
      case Constants.SetCardTypeFilterArray:
         return {...state, cardTypeFilterArray: action.cardTypeArray};
      case Constants.AddValueToCardTypeFilter: {
         let newArray = state.cardTypeFilterArray.slice().push({id: action.id, value: action.value});
         return {...state, cardTypeFilterArray: newArray}
      }
      case Constants.RemoveValueFromCardTypeFilter: {
         let newArray = state.cardTypeFilterArray.filter(f => f.id !== action.id);
         return {...state, cardTypeFilterArray: newArray}
      }
      case Constants.ClearCardTypeFilter: {
         return {...state, cardTypeFilterArray: []}
      }
      case Constants.AddValueToDeckFilter: {
         let newArray = state.idDeckFilterArray.slice();
         newArray.push(action.value);
         return {...state, idDeckFilterArray: newArray}
      }
      case Constants.RemoveValueFromDeckFilter: {
         let newArray = state.idDeckFilterArray.slice();
         Utils.deleteValueFromArray(action.value, newArray);
         return {...state, idDeckFilterArray: newArray}
      }
      case Constants.ClearDeckFilter: {
         return {...state, idDeckFilterArray: []}
      }
      case Constants.SetCheckForValidationErrors:
         return {...state, checkForValidationErrors: action.value};
      case Constants.SetSearchString:
         return {...state, searchString: action.searchString};
      case Constants.SetShowLinkBtn:
         return {...state, showLinkBtn: action.showLinkBtn};
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setAllTopics = (topics) =>{
   return{
      type: Constants.SetAllTopics,
      topics
   }
};

FunctionList.setTopicFilterArray = (topicArray) => {
   return{
      type: Constants.SetTopicFilterArray,
      topicArray
   }
};

FunctionList.addValueToTopicFilter = (id, value) => {
   return{
      type: Constants.AddValueToTopicFilter,
      id,
      value
   }
};

FunctionList.removeValueFromTopicFilter = (value) => {
   return{
      type: Constants.RemoveValueFromTopicFilter,
      value
   }
};

FunctionList.clearTopicFilter = () => {
  return{
     type: Constants.ClearTopicFilter
  }
};

FunctionList.setCardTypeFilterArray = (cardTypeArray) => {
   return{
      type: Constants.SetCardTypeFilterArray,
      cardTypeArray
   }
};

FunctionList.addValueToCardTypeFilter = (id, value) => {
   return{
      type: Constants.AddValueToCardTypeFilter,
      id,
      value
   }
};

FunctionList.removeValueFromCardTypeFilter = (value) => {
   return{
      type: Constants.RemoveValueFromCardTypeFilter,
      value
   }
};

FunctionList.clearCardTypeFilter = () => {
   return{
      type: Constants.ClearCardTypeFilter
   }
};

FunctionList.addValueToDeckFilter = (value) => {
   return{
      type: Constants.AddValueToDeckFilter,
      value
   }
};

FunctionList.removeValueFromDeckFilter = (value) => {
   return{
      type: Constants.RemoveValueFromDeckFilter,
      value
   }
};

FunctionList.clearDeckFilter = () => {
   return{
      type: Constants.ClearDeckFilter
   }
};

FunctionList.setCheckForValidationErrors = (value) =>{
   return{
      type: Constants.SetCheckForValidationErrors,
      value
   }
};

FunctionList.setSearchString = (searchString) =>{
   return{
      type: Constants.SetSearchString,
      searchString
   }
};

FunctionList.setShowLinkBtn = (showLinkBtn) =>{
   return{
      type: Constants.SetShowLinkBtn,
      showLinkBtn
   }
};

exports.FunctionList = FunctionList;
